import React from 'react';
import PropTypes from 'prop-types';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import CheckIcon from '@mui/icons-material/Check';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';

import { BLACK, FEED_BACK } from '../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../theme/fontConstants';

export const CHECKLIST_VARIANT = {
  REQUIREMENT: 'requirement',
  NAV: 'nav',
};

const textStyles = {
  [CHECKLIST_VARIANT.REQUIREMENT]: { color: BLACK[100], fontFamily: PRIMARY_FONT[700] },
  [CHECKLIST_VARIANT.NAV]: { color: BLACK[70], fontFamily: PRIMARY_FONT[400] },
};

const ChecklistItem = ({
  labelKey,
  isComplete,
  variant = CHECKLIST_VARIANT.REQUIREMENT,
  onClick,
}) => {
  const label = LanguageConverterV2(labelKey);
  const isNav = variant === CHECKLIST_VARIANT.NAV;

  const content = (
    <>
      {isComplete ? (
        <CheckIcon
          data-testid="checklist-item-complete"
          sx={{ color: FEED_BACK.GREEN_70, fontSize: '16px' }}
        />
      ) : (
        <RadioButtonUncheckedIcon
          data-testid="checklist-item-incomplete"
          sx={{ color: BLACK[50], fontSize: '14px', margin: '0 1px' }}
        />
      )}
      <Typography sx={{ fontSize: '13px', lineHeight: '20px', ...textStyles[variant] }}>
        {label}
      </Typography>
    </>
  );

  const rowSx = {
    alignItems: 'center',
    borderRadius: '4px',
    display: 'flex',
    gap: '8px',
    justifyContent: 'flex-start',
    padding: isNav ? '6px 8px' : '2px 0',
    textAlign: 'left',
    width: '100%',
  };

  if (onClick) {
    return (
      <ButtonBase onClick={onClick} sx={{ ...rowSx, '&:hover': { backgroundColor: BLACK[10] } }}>
        {content}
      </ButtonBase>
    );
  }

  return <Box sx={rowSx}>{content}</Box>;
};

ChecklistItem.propTypes = {
  labelKey: PropTypes.string.isRequired,
  isComplete: PropTypes.bool,
  variant: PropTypes.oneOf(Object.values(CHECKLIST_VARIANT)),
  onClick: PropTypes.func,
};

export default ChecklistItem;
